module.exports = ".mat-select{border-bottom:none}"